<yo-image-slider
  *ngIf="sliderImages.length"
  [slideHoldTime]="moduleData.holdSeconds * 1000"
  [sliderImages]="sliderImages"
></yo-image-slider>
